<template>
    <div class="login_pwd_root">
        <Top></Top>
        <div class="login_pwd_body___1UbSf ">
            <div class="side-menu-layout">
                <div class="content_menu">
                    <div class="menu___aQSZq">
                        <ul class="ant-menu kc-menu  ant-menu-light ant-menu-root ant-menu-inline">
                            <li class="ant-menu-item" :class="active == 'my' ? 'ant-menu-item-selected' : ''" style="padding-left: 16px;" @click="changeTab('/my','my')">
                                <a>账号概览</a>
                            </li>
                            <li class="ant-menu-item" :class="active == 'safe' ? 'ant-menu-item-selected' : ''" style="padding-left: 16px;" @click="changeTab('/safe','safe')">
                                <a>安全设置</a>
                            </li>
                            <li class="ant-menu-item" :class="active == 'realname' ? 'ant-menu-item-selected' : ''" style="padding-left: 16px;" @click="changeTab('/realname','realname')">
                                <a>实名认证</a>
                            </li>
                            <!--<li class="ant-menu-item" :class="active == 'information' ? 'ant-menu-item-selected' : ''" style="padding-left: 16px;" @click="changeTab('/information','information')">-->
                                <!--<a>基本资料</a>-->
                            <!--</li>-->
                            <li class="ant-menu-item" :class="active == 'api' ? 'ant-menu-item-selected' : ''" style="padding-left: 16px;" @click="changeTab('/api','api')">
                                <a>API管理</a>
                            </li>
                        </ul>
                    </div>
                </div>
                <div class="content_main">
                    <div class="ant-card withMinHeight___3Of57 ant-card-bordered ant-card-wider-padding">
                        <div class="ant-card-head">
                            <div class="ant-card-head-wrapper">
                                <div class="ant-card-head-title">
                                    <div class="cmpt_ct_flex___3Z286">
                                        <span class="cmpt_ct_back___58jfo cmpt_ct_flex___3Z286" @click="changeRoute('/safe')">
                                            <img src="@/assets/img/left_blue.png" alt="">
                                            <span>返回</span>
                                        </span>
                                        <span class="cmpt_ct_title___3zPlz">修改交易密码</span>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="ant-card-body">
                            <form class="ant-form ant-form-horizontal formWrapper___XJCyu">
                                <div class="formTitle___1a-ZI">修改交易密码</div>
                                <div class="AlertCmpt___1c86p">
                                    <div class="ant-alert ant-alert-warning AlertInfo___4bxp3 ">
                                        <img src="@/assets/img/zhuyi_orange.png" alt="">
                                        <span class="ant-alert-message">为了保障账户安全，修改成功后24h内禁止提现</span>
                                    </div>
                                </div>
                                <div class="formBody___-reP3">
                                    <div class="ant-row ant-form-item">
                                        <div class="ant-form-item-label ant-col-xs-24 ant-col-sm-24">
                                            <label for="oldPassword">原交易密码</label>
                                        </div>
                                        <div class="ant-form-item-control-wrapper ant-col-xs-24 ant-col-sm-24">
                                            <div class="ant-form-item-control">
                                                <span class="ant-form-item-children">
                                                    <input type="password" class="ant-input kc-input" id="oldPassword" placeholder="原交易密码">
                                                </span>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="ant-row ant-form-item">
                                        <div class="ant-form-item-label ant-col-xs-24 ant-col-sm-24">
                                            <label for="newPassword">新交易密码</label>
                                        </div>
                                        <div class="ant-form-item-control-wrapper ant-col-xs-24 ant-col-sm-24">
                                            <div class="ant-form-item-control">
                                                <span class="ant-form-item-children">
                                                    <input type="password" class="ant-input kc-input" id="newPassword" placeholder="新交易密码">
                                                </span>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="ant-row ant-form-item">
                                        <div class="ant-form-item-label ant-col-xs-24 ant-col-sm-24">
                                            <label for="newPassword2">重复交易密码</label>
                                        </div>
                                        <div class="ant-form-item-control-wrapper ant-col-xs-24 ant-col-sm-24">
                                            <div class="ant-form-item-control">
                                                <span class="ant-form-item-children">
                                                    <input type="password" class="ant-input kc-input" id="newPassword2" placeholder="请输入6位数字">
                                                </span>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="ant-btn  kc-button ant-btn-primary ant-btn-block" style="line-height:32px; -webkit-tap-highlight-color: rgba(0, 0, 0, 0);" @click="changeRoute('/safe')">
                                        <span>确认</span>
                                    </div>
                                    <div class="ant-row ant-form-item">
                                        <div class="ant-form-item-control-wrapper ant-col-xs-24 ant-col-sm-24">
                                            <div class="ant-form-item-control">
                                                <span class="ant-form-item-children">
                                                    <a class="depositTip___HmfmF" @click="changeRoute('/forget_deal_pwd')">忘记交易密码?</a>
                                                </span>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </form>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <Bottom></Bottom>
    </div>
</template>

<script>
    import Top from '@/components/top'
    import Bottom from '@/components/bottom'

    export default {
        name: "amend_deal_pwd",
        components: {
            Top, Bottom
        },
        data() {
            return {
                active: 'safe'
            }
        },
        methods: {
            changeTab: function (url, path) {
                this.active = path;
                this.changeRoute(url);
            }
        }
    }
</script>

<style scoped>
    @import "../../../assets/css/login_pwd.css";
</style>
